import React, { useState, useEffect } from 'react';
import axios from 'axios';

function EmailSettingsPage() {
  const [emails, setEmails] = useState([]);
  const [fromEmail, setFromEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [editingEmail, setEditingEmail] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = async () => {
    try {
      const response = await axios.get('https://test2.planfix-to-syrve.com/api/email-settings');
      console.log('Отримані дані:', response.data);
      
      if (response.data.success) {
        const data = response.data.data;
        
        if (data.emails && Array.isArray(data.emails)) {
          setEmails(data.emails);
        } else if (data.email) {
          setEmails([data.email]);
        } else {
          setEmails([]);
        }
        
        setFromEmail(data.from || '"Система замовлень" <bankdaolog@gmail.com>');
      }
    } catch (error) {
      console.error('Помилка:', error);
      setMessage('Помилка завантаження');
    } finally {
      setLoading(false);
    }
  };

  const addEmail = async () => {
    if (!newEmail.trim()) {
      setMessage('Введіть email');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      setMessage('Некоректний email');
      return;
    }
    
    try {
      const response = await axios.post('https://test2.planfix-to-syrve.com/api/email-settings/add', { email: newEmail });
      if (response.data.success) {
        const data = response.data.data;
        if (data.emails) {
          setEmails(data.emails);
        } else if (data.email) {
          setEmails([data.email]);
        }
        setNewEmail('');
        setMessage('Email додано');
        setTimeout(() => setMessage(''), 2000);
      }
    } catch (error) {
      setMessage(error.response?.data?.error || 'Помилка');
    }
  };

  const deleteEmail = async (emailToDelete) => {
    if (emails.length === 1) {
      setMessage('Не можна видалити останній email');
      return;
    }
    
    if (!confirm(`Видалити ${emailToDelete}?`)) return;
    
    try {
      const response = await axios.delete(`https://test2.planfix-to-syrve.com/api/email-settings/${encodeURIComponent(emailToDelete)}`);
      if (response.data.success) {
        const data = response.data.data;
        if (data.emails) {
          setEmails(data.emails);
        } else if (data.email) {
          setEmails([data.email]);
        }
        setMessage('Email видалено');
        setTimeout(() => setMessage(''), 2000);
      }
    } catch (error) {
      setMessage(error.response?.data?.error || 'Помилка');
    }
  };

  
  const startEdit = (email, index) => {
    setEditingEmail(index);
    setEditValue(email);
  };

  const cancelEdit = () => {
    setEditingEmail(null);
    setEditValue('');
  };

  const saveEdit = async (oldEmail) => {
    if (!editValue.trim()) {
      setMessage('Email не може бути порожнім');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(editValue)) {
      setMessage('Некоректний формат email');
      return;
    }
    
    if (editValue === oldEmail) {
      cancelEdit();
      return;
    }
    
    if (emails.includes(editValue)) {
      setMessage('Такий email вже існує');
      return;
    }
    
    try {
      
      const updatedEmails = [...emails];
      updatedEmails[editingEmail] = editValue;
      
      
      const response = await axios.post('https://test2.planfix-to-syrve.com/api/email-settings', {
        emails: updatedEmails,
        from: fromEmail
      });
      
      if (response.data.success) {
        setEmails(updatedEmails);
        setMessage('Email відредаговано');
        setTimeout(() => setMessage(''), 2000);
        cancelEdit();
      }
    } catch (error) {
      setMessage(error.response?.data?.error || 'Помилка редагування');
    }
  };

  const saveFromEmail = async () => {
    try {
      const response = await axios.post('https://test2.planfix-to-syrve.com/api/email-settings', {
        emails: emails,
        from: fromEmail
      });
      if (response.data.success) {
        setMessage('Збережено');
        setTimeout(() => setMessage(''), 2000);
      }
    } catch (error) {
      setMessage('Помилка');
    }
  };

  const testEmail = async () => {
    try {
      const response = await axios.post('https://test2.planfix-to-syrve.com/api/email-settings/test');
      setMessage(response.data.message);
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Помилка відправки');
    }
  };

  if (loading) return <div>Завантаження...</div>;

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Налаштування email</h2>
      
      {message && (
        <div style={{ 
          padding: '10px', 
          background: message.includes('Помилка') ? '#ffcccc' : '#ccffcc', 
          margin: '10px 0', 
          borderRadius: '4px' 
        }}>
          {message}
        </div>
      )}

      <div style={{ border: '1px solid #ddd', padding: '15px', margin: '20px 0', borderRadius: '4px' }}>
        <h3>Список email адрес</h3>
        
        {emails.length === 0 ? (
          <p style={{ color: 'red' }}>Немає email адрес</p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {emails.map((email, idx) => (
              <li key={idx} style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                padding: '8px',
                borderBottom: '1px solid #eee'
              }}>
                {editingEmail === idx ? (
                  <div style={{ flex: 1, display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <input
                      type="email"
                      value={editValue}
                      onChange={(e) => setEditValue(e.target.value)}
                      style={{ flex: 1, padding: '6px', border: '1px solid #007bff', borderRadius: '4px' }}
                      autoFocus
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') saveEdit(email);
                      }}
                    />
                    <button 
                      onClick={() => saveEdit(email)}
                      style={{ padding: '4px 12px', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                    >
                      💾
                    </button>
                    <button 
                      onClick={cancelEdit}
                      style={{ padding: '4px 12px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                    >
                      ✖
                    </button>
                  </div>
                ) : (
                  <>
                    <span>{email}</span>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button 
                        onClick={() => startEdit(email, idx)}
                        style={{ 
                          padding: '4px 12px', 
                          background: '#ffc107', 
                          color: '#333', 
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        ✏️ Редагувати
                      </button>
                      <button 
                        onClick={() => deleteEmail(email)}
                        style={{ 
                          padding: '4px 12px', 
                          background: '#dc3545', 
                          color: 'white', 
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        Видалити
                      </button>
                    </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}

        <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
          <input
            type="email"
            placeholder="Новий email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            style={{ flex: 1, padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') addEmail();
            }}
          />
          <button 
            onClick={addEmail}
            style={{ padding: '8px 16px', background: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            Додати
          </button>
        </div>
      </div>

   

    </div>
  );
}

export default EmailSettingsPage;
